import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import { IBankAccount } from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class BankAccount
  extends BaseModel<BankAccount, 'BankAccount'>
  implements IBankAccount
{
  name!: string;
  iban!: string;
  swift!: string;
  bankName!: string;
  bankCode!: string;
  balance!: number;
  currency!: string;
  openBankingAccountId!: string | null;
  @Type(() => Date)
  openBankingExpirationDate!: Date | null;
  default!: boolean;

  override get kind() {
    return 'BankAccount' as const;
  }
}
